import {motion} from 'framer-motion'

function PatientEdItem({image, heading, ed_text, img_alt_text, delay}) {
  return (
    <motion.li
     initial={{opacity: 0, x: -200}}
     whileInView={{opacity: 1, x: 0, transition: { duration: 0.3, delay: delay }}}
     viewport={{once: true, amount: 0.2}}
    >
        <div>
            <img src={image} alt={img_alt_text} />
        </div>
        <h1>{heading}</h1>
        <p>{ed_text}</p>
    </motion.li>
  )
}

PatientEdItem.defaultProps = {
  delay: 0
}

export default PatientEdItem